import React, { useState } from 'react';
import '../../styles/quiz-base.css';
import './nivelAtividade.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const NivelAtividade = ({ onSucesso }) => {
  const [selecionado, setSelecionado] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const opcoes = [
    { label: 'Sedentário', valor: 'sedentario', emoji: '🛋️', desc: 'Pouca ou nenhuma atividade física' },
    { label: 'Levemente ativo', valor: 'leve', emoji: '🚶‍♂️', desc: 'Atividades leves 1-3x por semana' },
    { label: 'Moderadamente ativo', valor: 'moderado', emoji: '🏃', desc: 'Exercícios moderados 3-5x por semana' },
    { label: 'Muito ativo', valor: 'ativo', emoji: '🏋️', desc: 'Treinos pesados 6-7x por semana' },
    { label: 'Extremamente ativo', valor: 'extremo', emoji: '💪🔥', desc: 'Atividade física intensa diária + trabalho físico' }
  ];

  const handleEnviar = async () => {
    if (!selecionado) return;

    setEnviando(true);
    setErro('');

    try {
      const resposta = await fetch(`${API_BASE}/salvar-etapa.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          campo: 'nivel_atividade',
          valor: selecionado
        })
      });

      const dados = await resposta.json();

      if (dados.status === 'sucesso') {
        onSucesso();
      } else {
        setErro(dados.mensagem || 'Erro ao salvar. Tente novamente.');
      }
    } catch (error) {
      setErro('Erro ao conectar com o servidor.');
    }

    setEnviando(false);
  };

  return (
    <div className="quiz-etapa">
      <img src="/assets/logo1.png" alt="Logo NutriFitMe" className="quiz-logo" />

      <div className="quiz-progresso">
        <div className="quiz-progresso-barra">
          <div
            className="quiz-progresso-preenchido"
            style={{ width: '42.8%' }}
          />
        </div>
        <div className="quiz-progresso-texto">4 de 7</div>
      </div>

      <h2 className="quiz-pergunta">
        Qual é o seu nível de atividade física?
      </h2>

      <p className="quiz-texto-extra">
        Essa informação influencia no cálculo da sua taxa calórica.
      </p>

      <div className="quiz-opcoes">
        {opcoes.map((opcao) => (
          <div
            key={opcao.valor}
            className={`quiz-opcao quiz-opcao-coluna ${
              selecionado === opcao.valor ? 'selecionado' : ''
            }`}
            onClick={() => setSelecionado(opcao.valor)}
          >
            <div className="quiz-opcao-icone">{opcao.emoji}</div>
            <div>
              <strong>{opcao.label}</strong>
              <p className="quiz-opcao-desc">{opcao.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {erro && <p className="quiz-erro">{erro}</p>}

      {/* BOTÃO STICKY COM CARD — SÓ APARECE APÓS SELEÇÃO */}
      {selecionado && (
        <div className="quiz-botao-sticky">
          <button
            className={`quiz-botao ${!enviando ? 'ativo' : ''}`}
            onClick={handleEnviar}
            disabled={enviando}
          >
            {enviando ? 'Enviando...' : 'Continuar'}
          </button>
        </div>
      )}

      <div className="quiz-footer">
        <Footer />
      </div>
    </div>
  );
};

export default NivelAtividade;
